var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{ref:"bevelVectors",attrs:{"id":"bevel-vector","viewBox":"0 0 100 100","preserveAspectRatio":"none"}},[_c('path',{attrs:{"d":"M100,0 L100,90 L0,100 L0,0"}})])}
var staticRenderFns = []

export { render, staticRenderFns }